import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Index from '../views/index.vue'
import SecondPage from '../views/SecondPage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/index',
    children: [
      {
        path: '/index',
        name: 'Index',
        component: Index,
        // alias: '/'
      },
      {
        path: '/text',
        name: 'Text',
        component: () => import('../components/Text.vue')
      },
      {
        path: '/secondpage',
        name: 'SecondPage',
        component: SecondPage,
        children: [

        ]
      }
    ]
  }
]

const router = new VueRouter({
  // mode: "history",
  routes
})

export default router
